import * as React from 'react';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import PropertyUtil from 'src/util/PropertyUtil';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import { SelectItem } from 'src/models/common/SelectItem';
import { AnyObject } from 'react-final-form';
import * as _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import { FormApi } from 'final-form';
import MultiplePhoneNumber from '../TractComponents/MultiplePhoneNumber';
import PhoneNumberType from 'src/models/PhoneNumberType';
import Prefixes from 'src/models/Prefixes';
import Suffixes from 'src/models/Suffixes';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';

interface IRALOwnerFormProps {
    handleOnSubmit: (formValues: OwnerRAL) => void;
    ownerData: LeaseGenerationOwnerData;
    states: PagedResultSet<State>;
    phoneNumberTypes: Array<PhoneNumberType>;
}

interface IRALOwnerFormState {
    form: FormApi;
}

class RALOwnerForm extends React.Component<IRALOwnerFormProps, IRALOwnerFormState> {
    constructor(props: IRALOwnerFormProps) {
        super(props);
        this.state = { form: undefined };
    }

    componentWillUnmount(): void {
        this.setState({ form: undefined });
    }

    validateForm = (values: AnyObject) => {
        const errors: AnyObject = {};
        if (!_.get(values, 'ralOwner.stateId')) {
            _.set(errors, 'ralOwner.stateId', 'Required');
        }
        if (!_.get(values, 'ralOwner.surfaceOwnerAgentFirstName')) {
            _.set(errors, 'ralOwner.surfaceOwnerAgentFirstName', 'Required');
        }
        if (!_.get(values, 'ralOwner.surfaceOwnerAgentLastName')) {
            _.set(errors, 'ralOwner.surfaceOwnerAgentLastName', 'Required');
        }
        return errors;
    };

    parseOwnerDetailFormValues = (formValues: AnyObject) => {
        const updatedOwnerDetail = new OwnerRAL(formValues.ralOwner);
        console.log('ralownervalues', updatedOwnerDetail);
        this.props.handleOnSubmit(updatedOwnerDetail);
    };

    public render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.name)) : new Array<SelectItem>();
        const ralOwner = this.props.ownerData.ownerDetails as OwnerRAL;

        return (
            <div>
                <h2 style={{marginLeft: '3rem'}}>Relinquishing Act Land Owner Form</h2>
                <Form
                    onSubmit={this.parseOwnerDetailFormValues}
                    style={{padding: '3rem'}}
                    initialValues={{ ralOwner: ralOwner }}
                    validate={this.validateForm}
                    onFormCreated={(form) => {
                        this.setState({ form: form });
                    }}
                    hasFieldArray={true}
                >
                    <div>
                        <FormSelect 
                            name="ralOwner.stateId" 
                            label="State" 
                            items={selectStates} 
                            className="lh-fourth-width" 
                            isRequired={true} 
                        />
                        <FormSelect
                            name="ralOwner.surfaceOwnerAgentPrefix"
                            label="Surface Owner Agent Prefix"
                            items={Prefixes}
                            className="lh-fourth-width"
                        />
                        <FormSelect
                            name="ralOwner.surfaceOwnerAgentSuffix"
                            label="Surface Owner Agent Suffix"
                            items={Suffixes}
                            className="lh-fourth-width"
                            style={{marginLeft: '.5rem'}}
                        />
                        <FormTextBox
                            name="ralOwner.ssnTaxId"
                            label="Tax Id"
                            className="lh-fourth-width"
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                    <div>
                        <FormTextBox
                            name="ralOwner.surfaceOwnerAgentFirstName"
                            label="Surface Owner Agent First Name"
                            className="lh-fourth-width"
                            isRequired={true}
                        />
                        <FormTextBox 
                            name="ralOwner.surfaceOwnerAgentMiddleName" 
                            label="Surface Owner Agent Middle Name" 
                            className="lh-fourth-width" 
                        />
                        <FormTextBox
                            name="ralOwner.surfaceOwnerAgentLastName"
                            label="Surface Owner Agent Last Name"
                            className="lh-fourth-width"
                            isRequired={true}
                            style={{marginLeft: '.5rem'}}
                        />
                        <FormTextBox 
                            name="ralOwner.email" 
                            label="Email" 
                            className="lh-fourth-width"
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}> 
                            Spouse
                        </legend>
                    </fieldset>
                    <div>
                        <FormTextBox 
                            name="ralOwner.spouseFirstName" 
                            label="Spouse First Name" 
                            className="lh-fourth-width" 
                        />
                        <FormTextBox 
                            name="ralOwner.spouseLastName" 
                            label="Spouse Last Name" 
                            className="lh-fourth-width" 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}> 
                            Address
                        </legend>
                    </fieldset>
                    <div>
                        <FormTextBox 
                            name="ralOwner.address.addressLine1" 
                            label="Address Line 1" 
                            className="lh-half-width" 
                        />
                        <FormTextBox 
                            name="ralOwner.address.addressLine2" 
                            label="Address Line 2" 
                            className="lh-half-width" 
                        />
                    </div>
                    <div>
                        <FormTextBox 
                            name="ralOwner.address.city" 
                            label="City" 
                            className="lh-third-width" 
                        />
                        <FormSelect 
                            name="ralOwner.address.stateId" 
                            label="State" 
                            items={selectStates} 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="ralOwner.address.zipCode" 
                            label="Zip Code" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                    <div>
                        <FormCheckbox 
                            name="ralOwner.isClientAcreage" 
                            label="This is the Client" 
                        />
                    </div>
                    <div style={{marginLeft: '.5rem'}}>
                        <MultiplePhoneNumber 
                            baseFieldName="ralOwner" 
                            form={this.state.form} 
                            phoneNumberTypes={this.props.phoneNumberTypes} 
                        />
                    </div>
                    <div className="button-row">
                        <Button 
                            text="Save" 
                            type="submit" 
                            intent="primary" 
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                </Form>
            </div>
        );
    }
}

export default RALOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/RALOwnerForm.tsx